import { createSelector } from 'reselect';
import { getMetric } from '../../../ReportByReactivation/ReportByReactivation.selectors';
import ReportByReactivationComponent from '../../../../utils/ReportByReactivationComponent/ReportByReactivationComponent';

const reportUtils = ReportByReactivationComponent.utils;

const location = (state) => state.routing?.location || state.routing?.locationBeforeTransitions || {};
const rows = (state) => state.statistics.data.rows;
const totals = (state) => state.statistics.data.totals;
const parameters = (state) => state.statistics.data.parameters;
const offers = (state) => state.offers.list;
const goals = (state) => state.goals.list;
const links = (state) => state.links.list;
const regions = (state) => state.regions.list;
const report = (state) => state.serverStorage.store.report;

export const getData = createSelector(
    rows,
    totals,
    parameters,
    offers,
    goals,
    links,
    regions,
    location,
    report,
    (rows = [], totals = {}, parameters = {}, offers = [], goals = [], links = [], regions = [], location = {}, report) => {
        let metrics = (location.query && location.query.metrics) || reportUtils.getDefStrMetric();
        let keysMetric = reportUtils.getKeysMetric(metrics);
        let data = [];

        if (Object.keys(totals).length) {
            data.push(keysMetric.map((key) => key === 'GroupBy' ? getMetric(key, totals[key], parameters, true) : totals[key]));
        }

        rows.map((item) => {
            data.push(keysMetric.map((key) => key === 'GroupBy' ? getMetric(key, item[key], parameters) : item[key]));
        });

        return data;
    }
);

export const getHeaderName = createSelector(
    parameters,
    location,
    report,
    (parameters = {}, location = {}, report) => {
        let list = [];

        let metrics = (location.query && location.query.metrics) || reportUtils.getDefStrMetric();
        let keysMetric = reportUtils.getKeysMetric(metrics);

        reportUtils.setKeyGroupBy(parameters.group_by);
        keysMetric.map((key) => {
            list.push(reportUtils.getTitleChain(key));
        });

        return list;
    }
);
